import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 61E83433-F6D1-442D-9EDE-EDEF27AB789D
 * name rewind-outline
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/rewind-outline.svg
 * tags
 */
export const RewindOutlineIcon = createSvgIcon(<><path d="M10,9.9L7,12L10,14.1V9.9M19,9.9L16,12L19,14.1V9.9M12,6V18L3.5,12L12,6M21,6V18L12.5,12L21,6Z" /></>, 'RewindOutlineIcon');
export default RewindOutlineIcon